import React from 'react';
import { ISearchInput } from '../types';
import SwitchiOS from '../../../../components/SwitchiOS';
import * as AdvancedSearchMenuUI from './AdvancedSearchMenuUI';

interface IProps {
  searchInput: ISearchInput;
  setSearchInput: (searchInput: ISearchInput, isLoadMore: boolean) => void;
}

const ShowFailedReportsOption = ({ searchInput, setSearchInput }: IProps) => {
  const handleToggle = () => {
    setSearchInput(
      {
        ...searchInput,
        failedReports: !searchInput.failedReports,
      },
      false,
    );
  };

  return (
    <AdvancedSearchMenuUI.SectionContainer>
      <AdvancedSearchMenuUI.SectionHeading>
        Show Failed Reports
      </AdvancedSearchMenuUI.SectionHeading>
      <SwitchiOS isChecked={searchInput.failedReports} onClick={handleToggle} />
    </AdvancedSearchMenuUI.SectionContainer>
  );
};

export default ShowFailedReportsOption;
